import { useEffect, useState } from 'react'
import styles from './incidentreport.module.css'

import constants from '../../../constants.js';
import api from '../../../routes/api.js';

import { useSidebarProvider } from '../../../providers/SidebarProvider.js';


const IncidentReport = ({setSelectedMenuItem}) => {

  const formLink = constants.forms.codeOfConduct + "?hideTitle=1&transparentBackground=1&dynamicHeight=1";
  const { setIsSidebarShowing } = useSidebarProvider();

  useEffect(() => {
    // If the page is loading on a small width, hide the sidebar so you see the page
    if (window.innerWidth < 1300){
      setIsSidebarShowing(false);
    }

    const widgetScriptSrc = 'https://tally.so/widgets/embed.js';

    const load = () => {
      // Load Tally embeds
      if (typeof Tally !== 'undefined') { // eslint-disable-next-line no-undef
        Tally.loadEmbeds(); // eslint-disable-next-line no-undef
        return;
      }

      // Fallback if window.Tally is not available
      document
        .querySelectorAll('iframe[data-tally-src]:not([src])')
        .forEach((iframeEl) => {
          iframeEl.src = iframeEl.dataset.tallySrc;
        });
    };
    
    // If Tally is already loaded, load the embeds
    if (typeof Tally !== 'undefined') { // eslint-disable-next-line no-undef
      load();
      return;
    }

    // If the Tally widget script is not loaded yet, load it
    if (document.querySelector(`script[src="${widgetScriptSrc}"]`) === null) {
      const script = document.createElement('script');
      script.src = widgetScriptSrc;
      script.onload = load;
      script.onerror = load;
      document.body.appendChild(script);
      return;
    }
    setSelectedMenuItem("");
  });

  return (
    <div className={styles.Registration}>
      <div className={styles.Title}>{constants.titles.incidentReport}</div>
      <iframe
        data-tally-src={formLink}
        loading="lazy"
        width="100%"
        title={constants.titles.incidentReport}
        key={"cplRulebook"}>
      </iframe>

    </div>
  )
}

export default IncidentReport;